import { createSelector } from 'reselect'

const getTransactionData = ({ reconciliation }) => {
  return {
    transactionData: reconciliation?.transactionData,
    next: reconciliation?.next,
    previous: reconciliation?.previous,
  }
}

const getArchiveTransactionData = ({ reconciliation }) => {
  return {
    archiveTransactionData: reconciliation?.archiveTransactionData,
    next: reconciliation?.next,
    previous: reconciliation?.previous,
  }
}

const fetchingTranscationData = ({ reconciliation }) => {
  return reconciliation?.fetchingTransactionData
}

const fetchingArchiveTransactionData = ({ reconciliation }) => {
  return reconciliation?.fetchingArchiveTransactionData
}

const updateTransactionStatus = ({ reconciliation }) => {
  return reconciliation?.updatingArchiveTransactionData
}

export const reconciliationSelectors = {
  getTransactionData: createSelector(
    [getTransactionData],
    ({ next, previous, transactionData }) => {
      return {
        next,
        previous,
        transactionData: transactionData?.map((data, index) => {
          return {
            id: index + 1,
            status: data?.status,
            izGuid: data?.izGuid,
            izUploadDate: data?.izUploadDate,
            izTransactionDate: data?.izTransactionDate,
            izMerchantName: data?.izMerchantName,
            izAmount: data?.izAmount,
            paymentType: data?.paymentType,
            bankName: data?.bank?.name,
            bankAccountName: data?.bank?.accountName,
            bankTransactionId: data?.bankTransactionId,
            bankTransactionDate: data?.bankPostingDate,
            bankMerchantName: data?.bankMerchantName,
            bankAmount: data?.bankAmount,
            bankPaymentType: data?.bankPaymentType,
            subacctId: data?.bank?.id,
            ...data,
          }
        }),
      }
    },
  ),

  getArchiveTransactionData: createSelector(
    [getArchiveTransactionData],
    ({ next, previous, archiveTransactionData }) => {
      return {
        next,
        previous,
        archiveTransactionData: archiveTransactionData?.map((data, index) => {
          return {
            id: index + 1,
            status: data?.status,
            izGuid: data?.izGuid,
            izUploadDate: data?.izUploadDate,
            izTransactionDate: data?.izTransactionDate,
            izMerchantName: data?.izMerchantName,
            izAmount: data?.izAmount,
            paymentType: data?.paymentType,
            bankName: data?.bank?.name,
            bankAccountName: data?.bank?.accountName,
            bankTransactionId: data?.bankTransactionId,
            bankTransactionDate: data?.bankPostingDate,
            bankMerchantName: data?.bankMerchantName,
            bankAmount: data?.bankAmount,
            bankPaymentType: data?.bankPaymentType,
            subacctId: data?.bank?.id,
            ...data,
          }
        }),
      }
    },
  ),

  fetchingTranscationData: createSelector([fetchingTranscationData], (fetchingTranscationData) => {
    return fetchingTranscationData
  }),

  fetchingArchiveTranscationData: createSelector(
    [fetchingArchiveTransactionData],
    (fetchingArchiveTranscationData) => {
      return fetchingArchiveTranscationData
    },
  ),

  updateTransactionStatus: createSelector(
    [updateTransactionStatus],
    (updateTransactionStatus) => updateTransactionStatus,
  ),
}

export default reconciliationSelectors
